// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2CSG3","errorScreen":"App_errorScreen__1TPAj"};